export default __webpack_public_path__ + "static/media/1280x500_01.4bf05ce7.jpg";